import IntlCurrencyInput from 'components/inputCurrency';
import { DateInput } from 'components/Inputs/Date';
import { SelectInput } from 'components/Inputs/SelectInput';
import { Switch } from 'components/Inputs/Switch';
import { TextInput } from 'components/Inputs/TextInput';
import { LinearProgress } from 'components/LinearProgress';
import { FormMessage } from 'components/Message';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { IVoucherCreate } from 'types/Voucher';

import {
  Box,
  Grid,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

interface Props {
  update?: boolean;
  error?: string;
  success?: string;
  loading?: boolean;
}

export const VoucherForm: FC<Props> = ({ update, error, success, loading }) => {
  const { setValue, watch } = useFormContext<IVoucherCreate>();

  const [type, name, limited, dateLimited] = watch([
    'type',
    'name',
    'limited',
    'dateLimited',
  ]);

  return (
    <Paper variant="outlined" sx={{ border: '2px solid #FBB45F' }}>
      {loading && <LinearProgress />}
      <Box p={2}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item container spacing={2}>
            <Grid item container direction="row">
              <Grid justifyContent="flex-start" alignItems="center" item lg={4}>
                <Typography
                  variant="button"
                  color="inherit"
                  noWrap
                  sx={{ fontSize: 20, fontWeight: 500 }}
                >
                  DADOS CADASTRAIS
                </Typography>
              </Grid>

              {update && (
                <Grid item lg={8} justifyContent="flex-end" display="flex">
                  <Switch
                    name="active"
                    activeLabel="Cupom Ativado"
                    inactiveLabel="Cupom Inativado"
                  />
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} md={8}>
              <TextInput
                required
                name="description"
                id="description"
                label="Descrição"
                inputProps={{ maxLength: 64 }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextInput
                disabled={update}
                required={!update}
                name="name"
                id="name"
                label="Código do cupom"
                value={name.toUpperCase().trim()}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>

            <Grid item xs={12} md={8}>
              <SelectInput required name="type" id="type" label="Tipo">
                <MenuItem value="percentage">Percentual</MenuItem>
                <MenuItem value="fixed">Valor Fixo</MenuItem>
              </SelectInput>
            </Grid>

            <Grid item xs={12} md={4}>
              {type === 'fixed' ? (
                <TextInput
                  required
                  fullWidth
                  placeholder="Preço"
                  name="value"
                  InputProps={{
                    // @ts-ignore
                    inputComponent: IntlCurrencyInput,
                  }}
                  inputProps={{
                    maxLength: 24,
                  }}
                  // @ts-ignore
                  onChange={(_, value) => {
                    setValue('value', value, { shouldValidate: true });
                  }}
                  variant="outlined"
                />
              ) : (
                <TextInput
                  required
                  name="value"
                  id="value"
                  label="Valor"
                  type="number"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                />
              )}
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              style={{
                display: 'flex',
                alignSelf: 'center',
              }}
            >
              <Switch
                name="limited"
                activeLabel="Limite de uso (opcional)"
                inactiveLabel="Limite de uso (opcional)"
                onChange={() => {
                  setValue('quantity', 0);
                  setValue('limited', !limited);
                }}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <TextInput
                required={limited}
                disabled={!limited}
                name="quantity"
                id="quantity"
                label="Quantidade"
                type="number"
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignSelf: 'center',
              }}
            >
              <Switch
                name="dateLimited"
                activeLabel="Data de expiração (opcional)"
                inactiveLabel="Data de expiração (opcional)"
                onChange={() => {
                  setValue('expireAt', null);
                  setValue('dateLimited', !dateLimited);
                }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <DateInput
                required={dateLimited}
                disabled={!dateLimited}
                disablePast
                name="expireAt"
                label="Data de expiração"
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'flex-end',
                gap: 40,
              }}
            >
              <Typography>Usar recorrência</Typography>

              <Stack direction="row" spacing={1}>
                <Switch
                  name="forever"
                  id="forever"
                  activeLabel="Sim"
                  inactiveLabel="Não"
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {error && (
        <Box p={1}>
          <Grid container justifyContent="flex-end">
            <Grid item xs={6}>
              <FormMessage data={error} severity="error" />
            </Grid>
          </Grid>
        </Box>
      )}

      {success && (
        <Box p={1}>
          <Grid container justifyContent="flex-end">
            <Grid item xs={6}>
              <FormMessage data={success} severity="success" />
            </Grid>
          </Grid>
        </Box>
      )}
    </Paper>
  );
};

